//import FlexRow, { FlexRowProps } from './FlexRow';
import { Skeleton } from "@heroui/react";


export interface CheckBoxProps {
  isLoaded?:			boolean;
  // Greyed and inert: shows the value but cannot be toggled.
  isDisabled?:			boolean;
  size?:				string;
  toggled:				boolean;
  setToggled:			(val: boolean) => any;
}

const CheckBox = (props: CheckBoxProps) => {
  const sz =	props.size === undefined
  				?	'text-[36px]'
  				:	props.size;
  
  const loaded = props.isLoaded === undefined
  				 ?	true
  				 :	props.isLoaded;
  
  const out =
    <span className={[
        	  'material-icons',
        	  props.isDisabled
        	  ?	'cursor-not-allowed opacity-40'
        	  :	'cursor-pointer',
        	  sz,
        	  props.toggled
        	  ?	'!text-[--Primetime-main]'
        	  :	'!text-[--Mid-Grey]',
          ].join(" ")}
          aria-disabled={props.isDisabled ? true : undefined}
          onClick={() => {
            if (!props.isDisabled)
              props.setToggled(!props.toggled);
          }}>
      { props.toggled ? 'toggle_on' : 'toggle_off' }
    </span>;

  if (loaded)
    return out;
    
  return (
  <Skeleton isLoaded={loaded}>
    { out }
  </Skeleton>
  )
};

export default CheckBox;
